import { Button } from "@mui/material";
import React, { useState } from "react";
import DealTable from "./DealTable";
import CreateDealForm from "./CreateDealForm";

const tabs = ["Deals", "Create Deal"];

const Deal = () => {
  const [activeTab, setActiveTab] = useState("Deals");

  return (
    <div>
      <div className="flex gap-4">
        {tabs.map((item) => (
          <Button
            key={item}
            onClick={() => setActiveTab(item)}
            variant={activeTab === item ? "contained" : "outlined"}
          >
            {item}
          </Button>
        ))}
      </div>

      <div className="mt-5">
        {activeTab === "Deals" ? (
          <DealTable />
        ) : (
          <div className="mt-5 flex flex-col justify-center items-center py-6">
            <CreateDealForm />
          </div>
        )}
      </div>
    </div>
  );
};

export default Deal;